'use client'
import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle
} from "react";
import NavigationPanel from "./header-web-component/NavigationPanel";
import { fetchLoginData } from "./helper";
import "./App.css";

const isClient = () => typeof window !== "undefined";

const HeaderWeb = forwardRef(function HeaderWeb(
  {
    userData,
    middleware,
    environment,
    page_name,
    cooldown_time = 300000,
    extra_params,
    isClevertapOn
  },
  ref
) {
  const [userDetails, setUserDetails] = useState(null);
  const [isClientReady, setIsClientReady] = useState(false);

  const navDownloadIconRef = useRef(null); // 👈 This will point to DownloadIcon

  useImperativeHandle(ref, () => ({
    getDownloadIconElement: () => {
      console.log("💡 [HeaderWeb] getDownloadIconElement called");
      return navDownloadIconRef.current;
    }
  }));
  

  useEffect(() => {
    if (isClient()) {
      setIsClientReady(true);
    }
  }, []);

  useEffect(() => {
    if (!isClientReady) return;

    const fetchUserDetails = async (forceFetch = false) => {
      try {
        let storedUserDetails = sessionStorage.getItem("userDetails");
        if (!storedUserDetails || forceFetch) {
          sessionStorage.removeItem("userDetails");
          const data = await fetchLoginData(middleware, page_name);
          if (data && Object.keys(data).length > 0) {
            setUserDetails(data);
            sessionStorage.setItem("userDetails", JSON.stringify(data));
            sessionStorage.setItem("initialVisit", "true");
          }
        } else {
          setUserDetails(JSON.parse(storedUserDetails));
        }
      } catch (err) {
        console.error("Error fetching user details:", err);
      }
    };

    if (!sessionStorage.getItem("initialVisit")) {
      fetchUserDetails(true);
    } else {
      fetchUserDetails();
    }

    const intervalId = setInterval(() => {
      fetchUserDetails(true);
    }, 30 * 60 * 1000);

    return () => clearInterval(intervalId);
  }, [isClientReady]);

  return (
    <div style={{ position: "sticky", top: "0", zIndex: "9999999" }}>
      <NavigationPanel
        userData={userData || userDetails}
        middleware={middleware}
        environment={environment}
        page_name={page_name}
        isClevertapOn={isClevertapOn}
        cooldown_time={cooldown_time}
        extra_params={extra_params}
        navDownloadIconRef={navDownloadIconRef} // 👈 Pass ref down
      />
    </div>
  );
});

export default HeaderWeb;
